<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- Descrição -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="v-description"
              >
                <b-form-input
                  id="v-description"
                  v-model="executivePositionPlace.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  :disabled="!canEditOrInsert"
                  data-cy="description-input"
                />
                <small
                  data-cy="v-description-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Ativo -->
          <b-col
            v-if="executivePositionPlace.id"
            cols="12"
          >
            <b-form-group>
              <b-form-checkbox
                v-model="executivePositionPlace.ativo"
                :checked="executivePositionPlace.ativo"
                name="check-button"
                switch
                inline
                :disabled="!canEditOrInsert"
                data-cy="active-checkbox"
              >
                {{ executivePositionPlace.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      titleForm: 'Cadastro de Cargos Diretivos',
      required,
      executivePositionPlace: {
        nome: '',
        ativo: true,
      },
    }
  },
  computed: {
    ...mapState('executivePositionsSettingsModule', {
      executivePosition: state => state.executivePosition,
    }),
    canInsert() {
      return verificarPermissao('ROLE_CARGO_INSERIR')
    },
    canEdit() {
      return verificarPermissao('ROLE_CARGO_ATUALIZAR')
    },
    canEditOrInsert() {
      return (
        (!this.executivePositionPlace.id && this.canInsert)
        || (this.executivePositionPlace.id && this.canEdit)
      )
    },
  },
  mounted() {
    this.executivePositionPlace = JSON.parse(
      JSON.stringify(this.executivePosition),
    )
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch(
        'executivePositionsSettingsModule/resetExecutivePositions',
      )
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.executivePositionPlace.id) {
            this.$store
              .dispatch(
                'executivePositionsSettingsModule/editExecutivePositions',
                this.executivePositionPlace,
              )
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch(
                'executivePositionsSettingsModule/insertNewExecutivePositions',
                this.executivePositionPlace,
              )
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.executivePositionPlace = {
        nome: '',
        ativo: true,
      }
    },
  },
}
</script>
